import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CategoryInterface } from 'src/app/interfaces/lobby.interface';
import { ControlHelperService } from 'src/app/services/control/control-helper.service';
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "../../components.module";
import { CdnIconComponent } from '../../cdn-icon/cdn-icon.component';

@UntilDestroy()
@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    ComponentsModule,
    CdnIconComponent
  ]
})
export class NavigationItemComponent implements OnInit {
  @Input() data: CategoryInterface;
  @Input() isActive: boolean;
  @Input() isHorizontal = false;

  constructor(
    private controlHelper: ControlHelperService
  ) { }

  ngOnInit(): void {
    const dataId = isNaN(Number(this.data.action_param)) ? undefined : Number(this.data.action_param);
    this.controlHelper.activeLobbyCategory$
      .pipe(
        untilDestroyed(this)
      )
      .subscribe((activeCategory: CategoryInterface | null) => {
        //Default to false
        this.isActive = false;

        //Check by ID matching (primary case)
        if (activeCategory && activeCategory.id === this.data.id) {
          this.isActive = true;
          return;
        }

        //Check action_param ID for HOME selection
        if (activeCategory && dataId !== undefined && activeCategory.id === dataId) {
          this.isActive = true;
          return;
        }
        // If none of the above conditions are met, isActive remains false (as initialized)
      });
  }

}
